import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { FaPhone, FaPhoneSlash } from "react-icons/fa";
import { toggleDialer } from "../../redux/actions/globalDialerAction";
import "./global-dialer-indicator.css";

const GlobalDialerIndicator = () => {
  const dispatch = useDispatch();
  const { isDialerOpen, phoneNumber, callStatus } = useSelector(
    (state) => state.globalDialer
  );
  const isToggled = useSelector((state) => state.DarkThemeReducer.isToggled);

  // Only show indicator if there's an active phone number and call
  if (!phoneNumber || callStatus === "idle") {
    return null;
  }

  const handleToggle = () => {
    dispatch(toggleDialer());
  };

  const getStatusColor = () => {
    switch (callStatus) {
      case "dialing":
      case "calling":
        return "#4caf50"; // Green
      case "initiating":
        return "#ff9800"; // Orange
      case "ended":
        return "#f44336"; // Red
      default:
        return "#9e9e9e"; // Gray
    }
  };

  return (
    <div
      className={`global-dialer-indicator ${
        isToggled ? "dark-theme" : "light-theme"
      }`}
      onClick={handleToggle}
      title={isDialerOpen ? "Hide Dialer" : "Show Dialer"}
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 9998,
        backgroundColor: getStatusColor(),
        color: "#fff",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
        transition: "all 0.3s ease",
      }}
    >
      <div
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {callStatus === "ended" ? (
          <FaPhoneSlash size={24} />
        ) : (
          <FaPhone size={24} />
        )}
        {(callStatus === "dialing" || callStatus === "calling") && (
          <span
            className="pulse-ring"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              border: "3px solid #fff",
              animation: "pulse 2s infinite",
            }}
          />
        )}
      </div>
      {!isDialerOpen && (
        <div
          style={{
            position: "absolute",
            bottom: "-8px",
            right: "-8px",
            backgroundColor: "#fff",
            color: getStatusColor(),
            borderRadius: "50%",
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "10px",
            fontWeight: "bold",
            border: `2px solid ${getStatusColor()}`,
          }}
        >
          1
        </div>
      )}
    </div>
  );
};

export default GlobalDialerIndicator;
